import { shallowEqual } from "react-redux";
import type { EcoConsumptionSectionType } from "../../../../shared-modules/eco-consumption-section/types/EcoConsumptionType";
import { useBnbSelector } from "../../redux/store";

export const useEcoConsumptionConfiguration = (): EcoConsumptionSectionType | false => {
    const { configuration, initialized } = useBnbSelector(({ ecoConsumption }) => ecoConsumption, shallowEqual);
    if (!initialized || !configuration || !configuration.areas.length) return false;

    return configuration;
};
